import {createSelector} from 'reselect';

import {getAccountId} from '../../../../services/selectors';

import type {State as RangesState} from './reducers/ranges';
import type {SettingsById} from './reducers/setupData';
import type {InputSelector} from 'src/modules/profile/account/tabs/admin-account-api-v2/services/typedef';
import type {Error} from 'src/openapi/admin/models/Error';
import type {IpRangeSection} from 'src/openapi/admin/models/IpRangeSection';
import type {Settings} from 'src/openapi/admin/models/Settings';
import type {AppState} from 'src/store/typedef';


export const getSetupData: InputSelector<void, SettingsById> = state => state.apiv2.setupData.data;
export const getSetupBusy: InputSelector<void, boolean> = state => state.apiv2.setupData.setupBusy;
export const getSetupError: InputSelector<void, Error | null> = state => state.apiv2.setupData.error;
export const getRanges: InputSelector<void, RangesState> = state => state.apiv2.ranges;

export const setupDataSelector = createSelector<AppState, number, SettingsById, Settings | null>(
    getAccountId,
    getSetupData,
    (accountId, data) => (accountId && data[accountId] ? data[accountId] : null),
);

export const rangesSelector = createSelector<AppState, number, RangesState, IpRangeSection | null>(
    getAccountId,
    getRanges,
    (accountId, ranges) => (accountId ? ranges[accountId] : null),
);

export const crmIntegrationSelector = createSelector<AppState, number, SettingsById, boolean>(
    getAccountId,
    getSetupData,
    (accountId, setupData) => {
        return accountId ? !!setupData[accountId]?.crmIntegration : false;
    },
);
